"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_watch__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "601b0a5e-6221-43bd-9a0b-d95ad5140bdf",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "9c60eb13-998d-4b5d-9a1d-c2aa2bfeaafe",
    x1: 82.26,
    y1: 130.24,
    x2: 121.43,
    y2: 169.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "watch-hi-dark"), /*#__PURE__*/React.createElement("path", {
    d: "M147,108h-5a2,2,0,0,1-2-2V86a2,2,0,0,1,2-2h5a5,5,0,0,1,5,5v14A5,5,0,0,1,147,108Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148,92h-8a2,2,0,0,1,0-4h8a2,2,0,0,1,0,4Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,98h-8a2,2,0,0,1,0-4h8a2,2,0,0,1,0,4Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,104h-8a2,2,0,0,1,0-4h8a2,2,0,0,1,0,4Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.7,176H81.3a10,10,0,0,1-9.93-8.76L68,140.5a4,4,0,0,1,4-4.5h48a4,4,0,0,1,4,4.5l-3.34,26.74A10,10,0,0,1,110.7,176Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,56H72a4,4,0,0,1-4-4.5l3.34-26.74A10,10,0,0,1,81.3,16h29.4a10,10,0,0,1,9.93,8.76L124,51.5a4,4,0,0,1-4,4.5Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122,46H70c-.43,0-.86,0-1.29,0l-.25,2C69,48,69.48,48,70,48h52c.52,0,1,0,1.54.06l-.25-2C122.86,46,122.43,46,122,46Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M122,144H70a22,22,0,0,1-22-22V70A22,22,0,0,1,70,48h52a22,22,0,0,1,22,22v52A22,22,0,0,1,122,144Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.83,140H72.17A20.2,20.2,0,0,1,52,119.83V72.17A20.2,20.2,0,0,1,72.17,52h47.66A20.2,20.2,0,0,1,140,72.17v47.66A20.2,20.2,0,0,1,119.83,140Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,142H70a22,22,0,0,1-22-22v2a22,22,0,0,0,22,22h52a22,22,0,0,0,22-22v-2A22,22,0,0,1,122,142Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.5,97.87H96A1.87,1.87,0,0,1,94.13,96V65.5a1.87,1.87,0,0,1,3.74,0V94.13H118.5a1.87,1.87,0,0,1,0,3.74Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.5,96.74H96a1.87,1.87,0,0,1-1.87-1.87V96A1.87,1.87,0,0,0,96,97.87h22.5A1.87,1.87,0,0,0,120.37,96a1.69,1.69,0,0,0-.1-.56A1.85,1.85,0,0,1,118.5,96.74Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,90",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.63,167.24l2.9-23.24h-55l32,32h10.2A10,10,0,0,0,120.63,167.24Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#9c60eb13-998d-4b5d-9a1d-c2aa2bfeaafe)"
  }));
}

var _default = ic_watch__dark;
exports.default = _default;